function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgResearch({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 64 64",
    id: "_x31_-outline-expand",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M29,16c0,7.732-6.268,14-14,14C7.268,30,1,23.732,1,16C1,8.268,7.268,2,15,2C22.733,2,29,8.268,29,16  L29,16z",
    style: {
      fill: "#E0C494"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.5,16c0,6.904-5.596,12.5-12.5,12.5C8.097,28.5,2.5,22.904,2.5,16C2.5,9.096,8.097,3.5,15,3.5  C21.904,3.5,27.5,9.096,27.5,16L27.5,16z",
    style: {
      fill: "#F2DAAE"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    style: {
      fill: "#EFBC2E"
    },
    width: 2,
    x: 14,
    y: 7
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#EFBC2E"
    },
    width: 4,
    x: 13,
    y: 6
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.5 -0.866 0.866 0.5 -6.3564 13.9901)",
    width: 2,
    x: 7.938,
    y: 10.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -6.3562 11.9919)",
    width: 4.001,
    x: 5.206,
    y: 10.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -8.5514 7.0799)",
    width: 4,
    x: 6.938,
    y: 18.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.001,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -9.2833 6.348)",
    width: 2,
    x: 6.206,
    y: 18.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    style: {
      fill: "#EFBC2E"
    },
    width: 2,
    x: 14,
    y: 21
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#EFBC2E"
    },
    width: 4,
    x: 13,
    y: 24
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.5 -0.866 0.866 0.5 -6.3563 27.9903)",
    width: 2,
    x: 20.063,
    y: 17.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.4999 -0.8661 0.8661 0.4999 -6.3552 29.9937)",
    width: 4.001,
    x: 20.795,
    y: 19.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -3.4281 12.2039)",
    width: 4,
    x: 19.063,
    y: 11.5
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4.001,
    style: {
      fill: "#EFBC2E"
    },
    transform: "matrix(0.8661 -0.4999 0.4999 0.8661 -2.6962 12.9358)",
    width: 2,
    x: 21.795,
    y: 9.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21,16c0,3.313-2.687,6-6,6c-3.313,0-6-2.687-6-6c0-3.313,2.687-6,6-6C18.313,10,21,12.687,21,16  L21,16z",
    style: {
      fill: "#AA494A"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19,16c0,2.208-1.791,4-4,4c-2.208,0-4-1.791-4-4c0-2.208,1.791-4,4-4C17.209,12,19,13.792,19,16  L19,16z",
    style: {
      fill: "#D36767"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 5.657,
    style: {
      fill: "#3A4249"
    },
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 10.1595 40.5272)",
    width: 5.657,
    x: 51.172,
    y: 5.172
  }), /*#__PURE__*/React.createElement("rect", {
    height: 11.314,
    style: {
      fill: "#3A4249"
    },
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 12.1595 41.3557)",
    width: 2,
    x: 55.001,
    y: 0.343
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49,17l11,11v30c0,2.209-1.791,4-4,4H26v-4c0-1.104,0.896-2,2-2h27V29l-9-9L49,17z",
    style: {
      fill: "#42A5B2"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 10,
    style: {
      fill: "#42A5B2"
    },
    width: 16,
    x: 34,
    y: 29
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "36,29 36,20 49,7 55,13 48,20 48,29 ",
    style: {
      fill: "#62C4C3"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    style: {
      fill: "#EFBC2E"
    },
    width: 4,
    x: 40,
    y: 39
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3A4249"
    },
    width: 23,
    x: 32,
    y: 46
  }), /*#__PURE__*/React.createElement("rect", {
    height: 4,
    style: {
      fill: "#EFBC2E"
    },
    width: 12,
    x: 36,
    y: 52
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62,37c0,2.209-1.791,4-4,4c-2.209,0-4-1.791-4-4c0-2.209,1.791-4,4-4C60.209,33,62,34.791,62,37  L62,37z",
    style: {
      fill: "#EFBC2E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60,37c0,1.104-0.895,2-2,2c-1.104,0-2-0.895-2-2c0-1.104,0.895-2,2-2C59.105,35,60,35.896,60,37  L60,37z",
    style: {
      fill: "#EF941D"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 13,
    y: 32
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 13,
    y: 36
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 13,
    y: 40
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 13,
    y: 44
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 13,
    y: 48
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 13,
    y: 52
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 13,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 17,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 21,
    y: 56
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 30,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 34,
    y: 10
  }), /*#__PURE__*/React.createElement("rect", {
    height: 2,
    style: {
      fill: "#3A4249"
    },
    width: 2,
    x: 38,
    y: 10
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResearch);
export default __webpack_public_path__ + "static/media/research.f23b9a6cc26510ade5e2003a5fc513a6.svg";
export { ForwardRef as ReactComponent };